<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Group Name"
                  v-model="productGroup.name"
                  type="text"
                  :rules="rules.productGroupNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Group Code"
                  v-model="productGroup.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Product Group Description"
                  v-model="productGroup.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productGroup.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productGroup.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <!-- <v-flex sm12 v-if="productGroup.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>-->
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addOperationSetting()" :disabled="btnDisabled">
                    Add Operation Setting
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs10>Operation Setting Name</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(productGroupDetail, index) in productGroup.productGroupDetails"
                  :key="index"
                >
                  <v-flex xs10>
                    <v-text-field
                      placeholder="Select the name"
                      v-model="productGroupDetail.operationSettingName"
                      @click="showOperationSetting(), selectedIndex = index"
                      :rules="operationRules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeOperationSetting(index, productGroupDetail.id)"
                      :disabled="index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid || btnDisabled" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <v-dialog v-model="showOperationSettingListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="operationTypes"
                label="Operation Type"
                v-model="queryParams.operationType"
                item-text="label"
                menu-props="auto"
                class="mr-1"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                class="mr-1"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="operationSettingList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td
                      @click="setProductGroupDetail(props.item.code, selectedIndex), showOperationSettingListDialog = !showOperationSettingListDialog"
                    >
                      <a>{{ props.item.code }}</a>
                    </td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>{{ props.item.operationType }}</td>
                    <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.updatedBy }}</td>
                    <td>
                      <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { productGroupService } from "../../services/product-group-service";
import { ProductGroup, ProductGroupDetail } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import {
  ProductGroupFormRules,
  OperationSettingFormRules,
} from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { operationSettingService } from "../../services/operation-setting-service";

export default {
  name: "ProductGroupDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Product Group",
        disabled: false,
        to: "product-groups",
      },
      {
        text: "Product Group Detail",
        disabled: true,
      },
    ],
    queryParams: {
      name: "",
      code: "",
      operationType: "",
      status: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    operationTypes: [],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "Operation Type", value: "operationType" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    rowsPerPageItems: [25, 50, 100],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    totalRows: 0,
    productGroup: new ProductGroup(),
    oldProductGroup: new ProductGroup(),
    productGroupDetail: new ProductGroupDetail(),
    statusFlag: true,
    saveLoading: false,
    showOperationSettingListDialog: false,
    showListLoading: false,
    rules: new ProductGroupFormRules(),
    operationRules: new OperationSettingFormRules(),
    operationSettingList: [],
    btnDisabled: false,
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new productGroup
      this.addOperationSetting();
    } else {
      this.getProductGroupDetail(id);
    }
    this.getAllOperationSettingType();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getOperationSettingList();
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.productGroup.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let productGroupObj = {
          id: this.productGroup.id ? this.productGroup.id : "",
          name: this.productGroup.name,
          code: this.productGroup.code,
          description: this.productGroup.description,
          status: this.productGroup.status,
          productGroupDetails: this.productGroup.productGroupDetails,
          deleteProductGroupDetailIds: this.productGroup
            .deleteProductGroupDetailIds,
        };
        productGroupService
          .saveProductGroup(productGroupObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getProductGroupDetail(id) {
      productGroupService
        .getProductGroupDetail(id)
        .then((res) => {
          this.productGroup = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.productGroup.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.productGroup.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldProductGroup = Object.assign({}, res.data);
          this.statusFlag = this.productGroup.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.productGroup.id) {
        this.productGroup = new ProductGroup();
        this.statusFlag = true;
        this.addOperationSetting();
      } else {
        this.productGroup = Object.assign({}, this.oldProductGroup);
        this.statusFlag = this.productGroup.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/product-groups");
    },
    addOperationSetting() {
      productGroupDetail = new ProductGroupDetail();
      let productGroupDetail = JSON.parse(
        JSON.stringify(this.productGroupDetail)
      );
      this.productGroup.productGroupDetails.push(productGroupDetail);
    },
    showOperationSetting() {
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.operationType = "";
      this.queryParams.status = "";
      this.getOperationSettingList().then(
        (this.showOperationSettingListDialog = !this
          .showOperationSettingListDialog)
      );
    },

    getAllOperationSettingType() {
      operationSettingService
        .getOperationSettingTypes()
        .then((res) => {
          if (res.data) {
            this.operationTypes = res.data;
            let findAll = {
              value: "",
              label: "---All---",
            };
            this.operationTypes.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    removeOperationSetting(index, productGroupDetailId) {
      if (productGroupDetailId) {
        if (!this.productGroup.deleteProductGroupDetailIds) {
          this.productGroup.deleteProductGroupDetailIds = [];
        }
        this.productGroup.deleteProductGroupDetailIds.push(
          productGroupDetailId
        );
      }
      this.$delete(this.productGroup.productGroupDetails, index);
    },
    getOperationSettingList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return operationSettingService
        .getOperationSettingList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.operationSettingList = res.data.operationSettingList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setProductGroupDetail(code, index) {
      let operationSetting = commonService.search(
        "code",
        code,
        this.operationSettingList
      );
      this.productGroup.productGroupDetails[index].operationSettingId =
        operationSetting.id;
      this.productGroup.productGroupDetails[index].code = operationSetting.code;
      this.productGroup.productGroupDetails[index].operationSettingName =
        operationSetting.name;
    },
  },
};
</script>

